import ColdPack from '@/components/common/ColdPack';
import pantryIcon from '@/components/pantry/PantryBtn/images/pantry_v5.png';
import { canIShow3LinesByTag } from '@/utils/common/product-card';
import useTranslation from 'next-translate/useTranslation';
import { twMerge } from 'tailwind-merge';
import { CardType, ProductCardProps } from '../../types';
import { useCallback, useMemo } from 'react';

const CardBodyProductName = (
  props: Partial<
    ProductCardProps &
      CardType & {
        productNameClass?: string;
        showPantryIcon?: boolean;
      }
  >
) => {
  const {
    data,
    className,
    cardType = 'vertical',
    isShow3Lines = true,
    productNameClass = '',
    showPantryIcon = true
  } = props;
  const { lang } = useTranslation('product-card');

  /**
   *  判断商品名是否展示3行的默认规则，显示3行必须以这个为前提
   * 1. 语言是'en', 'es', 'vi'之一
   * 2. 商品不是hotdish并且没有品牌名、没有赞助
   */
  const canIShow3LinesByDefaultRule = useCallback(() => {
    return cardType === 'vertical' && ['en', 'es', 'vi'].includes(lang) && canIShow3LinesByTag(data);
  }, [data]);

  const canIShow3Lines = useMemo(() => {
    return !productNameClass && canIShow3LinesByDefaultRule() && isShow3Lines;
  }, [productNameClass, canIShow3LinesByDefaultRule, isShow3Lines]);

  return (
    <div data-testid="wid-product-card-title" className={className}>
      <div
        data-role="product-title"
        className={twMerge(
          'text-surface-100-fg-default whitespace-pre-line',
          productNameClass || 'enki-body-xs',
          canIShow3Lines ? 'line-clamp-3' : 'line-clamp-2'
        )}>
        {props?.productNameSuffix}
        {data?.is_pantry && showPantryIcon && (
          <img
            className="image-render align-bottom mb-0.5 mr-1 w-auto break-all h-4 inline-block"
            alt="pantry image"
            src={pantryIcon}
            data-role="product-title-tag"
          />
        )}
        {data?.biz_type !== 'seller' && !data?.is_pantry && !!data?.is_colding_package && (
          <div className="inline" data-role="product-title-tag">
            <ColdPack />
          </div>
        )}
        {' ' + data?.name}
      </div>
    </div>
  );
};

export default CardBodyProductName;
